import { IConsultancy, inputConsultancy } from '~/types/consultancy-types'
import { normalizeCpfCnpj } from '~/utils/cnpj'

export function consultancyCreateMapper(requestType: IConsultancy) {
  return {
    ...requestType,
    documento: normalizeCpfCnpj(requestType.documento),
    celular: requestType?.celular
      ?.replace(/\s/g, '')
      ?.replace('(', '')
      ?.replace(')', '')
      ?.replace('+', '')
      ?.replace('55', ''),
  } as any
}

export function consultancyEditMapper(requestType: inputConsultancy) {
  return {
    ...requestType,
    documento: normalizeCpfCnpj(requestType.documento),
    cidade_id: requestType.cidade_id.id ?? '',
    celular: requestType?.celular
      ?.replace(/\s/g, '')
      ?.replace('(', '')
      ?.replace(')', '')
      ?.replace('+', '')
      ?.replace('-', '')
      ?.replace('55', ''),
  } as any
}
